

import { getAllInstitution } from 'api/institutions/institution.api';
import { create } from 'zustand';

interface IMunicipio {
    name: string;
}

export interface IMunicipiosStore {
    municipios: IMunicipio[];
    setMunicipios: (municipios: IMunicipio[]) => void;
    getMunicipios: () => void;
}

const useMunicipiosStore = create<IMunicipiosStore>((set) => ({
    municipios: [],
    setMunicipios: (municipios) => set({ municipios }),
    getMunicipios: async () => {
        const response = await getAllInstitution({
            take: '1000',
        });
        set({ municipios: response.data.map((item: any) => ({ name: item.name })) });
    }
}))

export default useMunicipiosStore;